import {useEffect, useState} from "react";
import {getSearchFilter, setSearchFilter} from "../modules/auth-persistor";
import {useNotifyEventsService} from "../services/notify-events-service";
import {AppEvents} from "../utils/constants";

export default function SearchFilter( {onChange=null, ...props} ){

    const [filter, _setFilter] = useState(null);
    const [tmpSearch, setTmpSearch] = useState('');

    const nes = useNotifyEventsService();

    function setFilter(newFilter, trigger=true){
        _setFilter(newFilter);
        setSearchFilter(newFilter);
        nes.trigger(AppEvents.searchFilterChanged, newFilter);
        if (trigger && 'function' === typeof onChange){
            onChange(newFilter);
        }
    }

    //init position as its needed for map init
    useEffect(() => {
        let f = getSearchFilter();
        setFilter(f, false);
        initTmpValues(f);

        nes.on(AppEvents.searchFilterChanged, reloadInternalFilter);
    }, [])

    function reloadInternalFilter(){
        const f = getSearchFilter();
        _setFilter(f);
        initTmpValues(f);
    }

    function initTmpValues(f=null, keys=['search']){
        if (!f){
            f = getSearchFilter();
        }
        if (!f){return false;}
        if (keys.includes('search')){
            setTmpSearch(f.search === null ? '' : f.search);
        }
    }

    function saveSearch(search){
        filter.search = search;
        setFilter(filter);
    }

    return (
        <>
            <div className="form-group w-100">
                <input name="tmpSearch" className="form-control p-2" value={tmpSearch} placeholder="search for..." onChange={(e) => saveSearch(e.target.value)}/>
            </div>
        </>
    );
}
